import Link from 'next/link';
import React from 'react';

import { capitalize } from '../../utils/formatters';
import { BASE_SEARCH_PATH } from '../../utils/search';

import Page from './Page';
import PageContent from './PageContent';

interface Props {
  /** lowercased entity name (e.g. "order", "class") */
  entity: string;
}

const NotFoundPage: React.FC<Props> = ({ entity }) => {
  return (
    <Page title={`${capitalize(entity)} Not Found`}>
      <PageContent initialData={null}>
        <article className="mx-auto w-full max-w-screen-xl px-4 pb-8">
          <div className="py-8 lg:flex">
            <div className="mt-6 lg:ml-6 lg:mt-0 lg:flex lg:flex-col lg:justify-between">
              <div className="text-lg leading-none">
                Couldn&rsquo;t find the requested {entity}.{' '}
                <Link
                  href={BASE_SEARCH_PATH}
                  className="link link--primary"
                  id="not_found_page--head_back_home"
                >
                  Head back home.
                </Link>
              </div>
            </div>
          </div>
        </article>
      </PageContent>
    </Page>
  );
};

export default NotFoundPage;
